import { createSelector } from "reselect";

const getMiniBag = state => state.miniBag;

export const getBag = createSelector(
  getMiniBag,
  miniBag => miniBag && miniBag.bag
);

export const getBagItems = createSelector(getBag, bag => bag && bag.items);

export const getTotalQuantity = createSelector(
  getBag,
  bag => bag && bag.summary && bag.summary.totalQuantity
);

export const getUpdated = createSelector(getBag, bag => bag.isUpdated);



// WEBPACK FOOTER //
// ./template/state/modules/miniBag/selectors.js